import React from 'react'

interface SpinnerProps {
  /** Diameter preset. */
  size?: 'small' | 'medium' | 'large' | 'massive'
  /** Optional centered caption below the spinner. */
  children?: React.ReactNode
  className?: string
}

const sizeClasses = {
  small: 'h-5 w-5 border-2',
  medium: 'h-8 w-8 border-2',
  large: 'h-12 w-12 border-[3px]',
  massive: 'h-16 w-16 border-4',
}

/**
 * Native replacement for Semantic UI's <Loader>. Renders a centered spinning ring
 * with an optional caption.
 */
export default function Spinner({ size = 'medium', children, className = '' }: SpinnerProps) {
  return (
    <div className={`flex flex-col items-center justify-center gap-3 ${className}`.trim()}>
      <div
        className={`inline-block animate-spin rounded-full border-b-brand-green border-l-transparent border-r-transparent border-t-transparent ${sizeClasses[size]}`}
      />
      {children != null && (
        <div className="font-nunito text-1-5xs text-primary text-center">{children}</div>
      )}
    </div>
  )
}
